export const SET_PAGINATED_REPORT_PARAMETERS_LOADED = "SET_PAGINATED_REPORT_PARAMETERS_LOADED";

export const setPaginatedReportParametersLoaded = (paginatedReportParametersLoaded: boolean) => {
    return {
        paginatedReportParametersLoaded,
        type: SET_PAGINATED_REPORT_PARAMETERS_LOADED
    };
};
